const STANDARD_INCIDENT_KEYS = new Set([
  'blackmailSextortion',
  'blackmailRansomware',
  'blackmailOther',
  'fraudNftAirdrop',
  'fraudPhishing',
  'fraudImpersonation',
  'fraudDonation',
  'fraudRomance',
  'fraudPigButchering',
  'fraudFakeProject',
  'fraudRugPull',
  'fraudFakeReturns',
  'fraudOther',
  'hackSimSwap',
  'hackContractExploit',
  'hackPasswordCrack',
  'hackPrivateKeyLeak',
  'hackOther',
  'other',
  'unknown',
]);

const EXACT_ENGLISH_MAP = {
  'Phishing Scam': 'fraudPhishing',
  'Rug Pull Scam': 'fraudRugPull',
  'Other Blackmail Scam': 'blackmailOther',
  'Sextortion Scam': 'blackmailSextortion',
  Ransomware: 'blackmailRansomware',
  'Impersonation Scam': 'fraudImpersonation',
  'Fake Returns Scam': 'fraudFakeReturns',
  'Hack - Other': 'hackOther',
  'NFT Airdrop Scam': 'fraudNftAirdrop',
  'Fake Project Scam': 'fraudFakeProject',
  'Romance Scam': 'fraudRomance',
  'Pigbutchering Scam': 'fraudPigButchering',
  'Contract Exploit Scam': 'hackContractExploit',
  'Donation Impersonation Scam': 'fraudDonation',
  'SIM Swap Scam': 'hackSimSwap',
  'Other Investment Scam': 'fraudOther',
  'Man-In-The-Middle Attack Scam': 'hackOther',
  Other: 'fraudOther',
  phishing: 'fraudPhishing',
  'Fake Return Scams: Secure Your Crypto Investments': 'fraudFakeReturns',
  'Phishing Scams: Stay Protected': 'fraudPhishing',
  'Crypto Hacks: Report and Stay Safe': 'hackOther',
  'Blackmail Scams: Report and Learn': 'blackmailOther',
  'Fraud Scams: Report and Stay Safe': 'fraudOther',
  'Romance Scams: Protect Your Heart and Wallet': 'fraudRomance',
  'Impersonation Scams: Verify Before You Trust': 'fraudImpersonation',
  'Rug Pull Scams: Do Your Research': 'fraudRugPull',
  'NFT Scams: Verify Before You Mint': 'fraudNftAirdrop',
};

const PATTERN_RULES = [
  [/fake\s*return/i, 'fraudFakeReturns'],
  [/phishing/i, 'fraudPhishing'],
  [/impersonation/i, 'fraudImpersonation'],
  [/rug\s*pull/i, 'fraudRugPull'],
  [/romance/i, 'fraudRomance'],
  [/pig\s*butchering|pigbutchering/i, 'fraudPigButchering'],
  [/nft/i, 'fraudNftAirdrop'],
  [/donation/i, 'fraudDonation'],
  [/sextortion/i, 'blackmailSextortion'],
  [/ransomware/i, 'blackmailRansomware'],
  [/blackmail/i, 'blackmailOther'],
  [/sim\s*swap/i, 'hackSimSwap'],
  [/contract\s*exploit/i, 'hackContractExploit'],
  [/private\s*key/i, 'hackPrivateKeyLeak'],
  [/password/i, 'hackPasswordCrack'],
  [/crypto\s*hack/i, 'hackOther'],
  [/\bhack/i, 'hackOther'],
  [/fraud|scam/i, 'fraudOther'],
];

export function resolveIncidentTypeKey(incidentType) {
  if (!incidentType) return 'unknown';

  const trimmed = incidentType.trim();
  if (STANDARD_INCIDENT_KEYS.has(trimmed)) return trimmed;

  if (EXACT_ENGLISH_MAP[trimmed]) return EXACT_ENGLISH_MAP[trimmed];

  for (const [pattern, key] of PATTERN_RULES) {
    if (pattern.test(trimmed)) return key;
  }

  return null;
}

export function translateIncidentType(incidentType, t) {
  if (!incidentType) return t('unknown');

  if (incidentType === 'other') {
    return t('other', { defaultValue: '其他' });
  }

  const key = resolveIncidentTypeKey(incidentType);
  if (key) {
    const translated = t(key);
    if (translated && translated !== key) return translated;
  }

  const direct = t(incidentType, { defaultValue: '' });
  if (direct && direct !== incidentType) return direct;

  return incidentType;
}

export function incidentTypeSearchText(incidentType, t) {
  const translated = translateIncidentType(incidentType, t);
  return `${incidentType} ${translated}`.toLowerCase();
}
